import React, { Fragment, useState } from 'react';
import { getNames as getCountries } from 'i18n-iso-countries';
import { ReactCountryFlag } from 'react-country-flag';
import './ProfileAccordionContent.css';
import { CheckBox } from '../../../../components/shared/CheckBox/CheckBox';
import { BigButton } from '../../../../components/buttons/BigButton/BigButton';
import { Border } from '../../../../components/Border/Border';

interface IProfileAccordionContentProps {
    contentIndex: number;
}
interface Item {
    code: number;
    date: string;
    cost: number;
    uses: number;
    active: boolean;
}
export const ProfileAccordionContent: React.FC<IProfileAccordionContentProps> = ({ contentIndex }) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [country, setCountry] = useState('');
    const [steamTradeLink, setSteamTradeLink] = useState('');
    const [showBalanceInventory, setShowBalanceInventory] = useState(false);
    const [showGangChat, setShowGangChat] = useState(false);
    const countries = getCountries('ru'); // Получение списка стран на русском языке
    const [name, setName] = useState('');
    const handleSaveChanges = () => {
        // Обработка и сохранение изменений
    };

    const [isBalanceInvent, setIsBalanceInvent] = useState<boolean>(false);
    const [isBandsInGeneral, setIsBandsInGeneral] = useState<boolean>(false);

    const [items, setItems] = useState<Item[]>([]);
    const [cost, setCost] = useState<number>(0);
    const [activationAmount, setActivationAmount] = useState<number>(0);
    const [codeAmount, setCodeAmount] = useState<number>(0);

    const generateCode = () => {
        const min = 10000000;
        const max = 99999999;
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    const addItem = () => {
        const formattedDate = new Intl.DateTimeFormat('ru-RU', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(new Date());

        const newItem: Item = {
            code: generateCode(),
            date: formattedDate,
            cost: parseFloat(cost.toFixed(2)),
            uses: 1 / 3,
            active: true,
        };
        setItems([...items, newItem]);
    };
    const handleCheckboxChangeBalance = (checked: boolean) => {
        console.log('Checkbox checked:', checked);
        setIsBalanceInvent(checked);
    };
    const handleCheckboxChangeBands = (checked: boolean) => {
        console.log('Checkbox checked:', checked);
        setIsBandsInGeneral(checked);
    };
    const checkBoxIdBalance = 'balance-invent';
    const checkBoxLabelBalance = 'Открытый баланс и инвентарь';

    const checkBoxIdBands = 'bands-in-general';
    const checkBoxLabelBands = 'Отображать чат банды в основном чате';

    switch (contentIndex) {
        case 0: {
            return (
                <div className="profile-accordion-content">
                    <label htmlFor="phone" className="profile-accordion-content__label">
                        Телефон для смс
                        <input
                            type="tel"
                            id="phone"
                            placeholder="Телефон для смс"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            className="profile-accordion-content__input"
                        />
                    </label>
                    <label htmlFor="email" className="profile-accordion-content__label">
                        Email
                        <input
                            type="email"
                            id="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="profile-accordion-content__input"
                        />
                    </label>
                    <label htmlFor="country" className="profile-accordion-content__label">
                        Страна
                        <select
                            id="country"
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            className="profile-accordion-content__country-select"
                        >
                            <option value="" disabled>
                                Страна
                            </option>
                            {Object.entries(countries).map(([code, name]) => (
                                <option key={code} value={code} className="profile-accordion-content__country-option">
                                    {name} <ReactCountryFlag countryCode={code as string} svg className="profile-accordion-content__country-flag" />
                                </option>
                            ))}
                        </select>
                    </label>
                    <label htmlFor="steamTradeLink" className="profile-accordion-content__label profile-accordion-content__label_trade-link">
                        Трейдлинк Steam
                        <input
                            type="text"
                            id="steamTradeLink"
                            placeholder="Трейдлинк Steam"
                            value={steamTradeLink}
                            onChange={(e) => setSteamTradeLink(e.target.value)}
                            className="profile-accordion-content__input"
                        />
                    </label>
                    <div className="profile-accordion-content__checkbox-container1">
                        <div className="profile-accordion-content__checkbox-cont">
                            <CheckBox
                                id={checkBoxIdBalance}
                                label={checkBoxLabelBalance}
                                checked={isBalanceInvent}
                                onChange={handleCheckboxChangeBalance}
                            />
                        </div>
                        <div className="profile-accordion-content__checkbox-cont">
                            <CheckBox
                                id={checkBoxIdBands}
                                label={checkBoxLabelBands}
                                checked={isBandsInGeneral}
                                onChange={handleCheckboxChangeBands}
                            />
                        </div>
                    </div>
                    <BigButton buttonText="Сохранить изменения" bgColor={'blue-blur'} />
                </div>
            );
        }
        case 1: {
            return (
                <div className="profile-accordion-content profile-accordion-content--second">
                    <label htmlFor="steamTradeLink" className="profile-accordion-content__label profile-accordion-content__label_trade-link">
                        Ссылка на канал на YouTube
                        <input
                            type="text"
                            id="steamTradeLink"
                            placeholder="YouTube"
                            value={steamTradeLink}
                            onChange={(e) => setSteamTradeLink(e.target.value)}
                            className="profile-accordion-content__input"
                        />
                    </label>
                    <label htmlFor="steamTradeLink" className="profile-accordion-content__label profile-accordion-content__label_trade-link">
                        Ссылка на канал на Twitch
                        <input
                            type="text"
                            id="steamTradeLink"
                            placeholder="Twitch"
                            value={steamTradeLink}
                            onChange={(e) => setSteamTradeLink(e.target.value)}
                            className="profile-accordion-content__input"
                        />
                    </label>
                    <BigButton buttonText="Сохранить изменения" bgColor={'blue-blur'} />
                </div>
            );
        }
        case 2: {
            return (
                <div className="profile-accordion-content profile-accordion-content--third">
                    <span className="profile-accordion-content__text">Для передачи поинтов необходимо cделать хотя бы 1 трейд на странице</span>
                    <button className="profile-accordion-content--fourth-button">Мой инвентарь →</button>
                </div>
            );
        }
        case 3: {
            return (
                <div className="profile-accordion-content profile-accordion-content--fourth">
                    <div className="profile-accordion-content__create-promo-codes">
                        <div className="profile-accordion-content__info-block">
                            <span className="profile-accordion-content__block-title">Мой баланс</span>
                            <span className="profile-accordion-content__block-info">15 067.00 р.</span>
                        </div>
                        <label htmlFor="phone" className="profile-accordion-content__label">
                            Поинты
                            <input
                                type="number"
                                id="phone"
                                placeholder="Введите сумму.."
                                value={cost}
                                onChange={(e) => setCost(parseFloat(e.target.value))}
                                className="profile-accordion-content__input profile-accordion-content__input-text"
                            />
                        </label>
                        <label htmlFor="phone" className="profile-accordion-content__label">
                            Активация
                            <input
                                type="number"
                                id="phone"
                                placeholder="Кол-во            шт."
                                value={activationAmount}
                                onChange={(e) => setActivationAmount(parseFloat(e.target.value))}
                                className="profile-accordion-content__input profile-accordion-content__input-text"
                            />
                        </label>
                        <label htmlFor="phone" className="profile-accordion-content__label">
                            Промокоды
                            <input
                                type="number"
                                id="phone"
                                placeholder="Кол-во            шт."
                                value={codeAmount}
                                onChange={(e) => setCodeAmount(parseFloat(e.target.value))}
                                className="profile-accordion-content__input profile-accordion-content__input-text"
                            />
                        </label>
                        <BigButton onClick={addItem} buttonText={'Создать промокод'} bgColor={'blue-blur'} />
                    </div>
                    <Border />
                    <div className="profile-accordion-content__promo-codes">
                        <span className="profile-accordion-content__promo-codes-title">Номер</span>
                        <span className="profile-accordion-content__promo-codes-title">Дата</span>
                        <span className="profile-accordion-content__promo-codes-title">Поинты</span>
                        <span className="profile-accordion-content__promo-codes-title">Активации</span>
                        <span className="profile-accordion-content__promo-codes-title">Промокоды</span>
                        <span className="profile-accordion-content__promo-codes-title"></span>
                        {items.map((item) => (
                            <Fragment key={item.code}>
                                <div className="profile-accordion-content__promo-code">#{item.code}</div>
                                <div className="profile-accordion-content__promo-code">{item.date}</div>
                                <div className="profile-accordion-content__promo-code">{item.cost}</div>
                                <div className="profile-accordion-content__promo-code">{item.uses}</div>
                                <div className="profile-accordion-content__promo-code">{item.uses}</div>
                                <div className="profile-accordion-content__promo-code">{item.active ? 'Активный' : 'Неактивный'}</div>
                            </Fragment>
                        ))}
                    </div>
                </div>
            );
        }
        default: {
            return (
                <div className="profile-accordion-content profile-accordion-content--default">
                    <p className="profile-accordion-content__text">Содержимое для аккордеона с индексом</p>
                </div>
            );
        }
    }
};
